export default {
    application(state) {
        return true;
    },
    all() {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/navbarPermissions.js